import { formatINR } from "@/utils/app-formatters";

import type { PaymentSummaryCardView, PaymentSummaryResponse, SummaryTone } from "./types";

export type PaymentSummaryConfigEntry = {
  key: keyof PaymentSummaryResponse;
  label: string;
  tone: SummaryTone;
};

export const DEFAULT_PAYMENT_SUMMARY_CONFIG: PaymentSummaryConfigEntry[] = [
  { key: "cash", label: "CASH", tone: "warning" },
  { key: "online", label: "ONLINE", tone: "info" },
  { key: "cheque", label: "CHEQUE", tone: "warning" },
  { key: "grandTotal", label: "GRAND TOTAL", tone: "success" },
];

export function buildPaymentSummaryQuery(
  filterValues: Record<string, unknown>,
  queryKeys: readonly string[]
): URLSearchParams {
  const params = new URLSearchParams();
  for (const key of queryKeys) {
    const value = filterValues[key];
    if (value != null && String(value).trim() !== "") {
      params.append(key, String(value));
    }
  }
  return params;
}

export function hasRequiredFilterKeys(
  filterValues: Record<string, unknown>,
  keys: readonly string[]
): boolean {
  return keys.every((key) => Boolean(filterValues[key]));
}

export function paymentSummaryCardsFromResponse(
  summary: PaymentSummaryResponse,
  config: readonly PaymentSummaryConfigEntry[] = DEFAULT_PAYMENT_SUMMARY_CONFIG
): PaymentSummaryCardView[] {
  const cards: PaymentSummaryCardView[] = [];
  for (const entry of config) {
    const data = summary[entry.key];
    if (!data) continue;
    cards.push({
      key: entry.key,
      label: entry.label,
      tone: entry.tone,
      totalFormatted: formatINR(data.total),
      countLabel: `${data.count} receipt${data.count !== 1 ? "s" : ""}`,
    });
  }
  return cards;
}
